import { get, post, put } from "./divertidogsApiUtils";
import { useQuery } from "@tanstack/react-query";

export interface ItemListadoServiciosHotel {
  id: string;
  nombre: string;
  descripcion?: string;
  precioNoche: number;
  minimoNoches?: number | null;
  maximoNoches?: number | null;
}

export const listarServiciosHotel = async (): Promise<
  ItemListadoServiciosHotel[] | undefined
> => {
  return get<ItemListadoServiciosHotel[]>(`servicios/hotel`);
};

export const QUERY_KEY_LISTAR_SERVICIOS_HOTEL =
  "QUERY_KEY_LISTAR_SERVICIOS_HOTEL";

export const useListarServiciosHotel = () => {
  return useQuery(
    [QUERY_KEY_LISTAR_SERVICIOS_HOTEL],
    async () => await listarServiciosHotel()
  );
};

export const QUERY_KEY_LISTAR_SERVICIOS_HOTEL_POR_TIPO =
  "QUERY_KEY_LISTAR_SERVICIOS_HOTEL_POR_TIPO";

export const useListarServiciosHotelPorTipo = () => {
  return useQuery(
    [QUERY_KEY_LISTAR_SERVICIOS_HOTEL_POR_TIPO],
    async () => await listarServiciosHotelPorTipo()
  );
};

export interface ServiciosGuarderiaPorTipo {
  tarifasIndividuales: ItemListadoServiciosHotel[];
  planes: ItemListadoServiciosHotel[];
}

export const listarServiciosHotelPorTipo = async () => {
  return get<ServiciosGuarderiaPorTipo>(`servicios/hotel/por_tipo`);
};

export interface NuevoServicioHotel {
  nombre: string;
  descripcion?: string;
  precioNoche: number;
  horaSalida?: number;
  minimoNoches?: number;
  maximoNoches?: number;
}

export const crearServicioHotel = async (
  nuevoServicioHotel: NuevoServicioHotel
): Promise<undefined> => {
  return post<NuevoServicioHotel, any | undefined>(
    "servicios/hotel",
    nuevoServicioHotel
  );
};

export interface ServicioHotel {
  id: string;
  nombre: string;
  descripcion?: string;
  precioNoche: number;
  horaSalida?: number;
  minimoNoches?: number;
  maximoNoches?: number;
}

export const buscarServicioHotel = async (
  id: string
): Promise<ServicioHotel | undefined> => {
  return get<ServicioHotel>(`servicios/hotel/${id}`);
};

export const QUERY_KEY_BUSCAR_SERVICIO_HOTEL = "buscar_servicio_hotel";

export const useBuscarServicioHotel = (id?: string) => {
  if (!id) {
    throw Error("Id de servicio no definido");
  }
  return useQuery(
    [QUERY_KEY_BUSCAR_SERVICIO_HOTEL],
    async () => await buscarServicioHotel(id)
  );
};

export const reemplazarServicioHotel = async (servicioHotel: ServicioHotel) => {
  return put<ServicioHotel, undefined>(`servicios/hotel`, servicioHotel);
};
